/**
 * @flow
 */
import { Box, Grid, Typography } from '@mui/material';
import { I18n } from 'utils/i18n';
import Header from 'components/@home/Header';
import OAuthAuthorize from 'components/@oauth/OAuthAuthorize';
import OAuthError from 'components/@oauth/OAuthError';
import Loading from 'components/common/Loading';
import deferRender from 'defer-render-hoc';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import OidcInteraction from 'services/api/OidcInteraction';

const OAuthScene = () => {
  const [loading, setLoading] = useState(true);
  const [interaction, setInteraction] = useState(null);
  const [error, setError] = useState(null);
  const { uid } = useParams();

  useEffect(() => {
    if (!uid) {
      setError(I18n.t('OAuth.Invalid client_id parameter'));
      setLoading(false);
      return;
    }

    OidcInteraction.getDetails(uid)
      .then(response => {
        setInteraction(response?.data);
        setLoading(false);
      })
      .catch(() => {
        setError(I18n.t('OAuth.Invalid client_id parameter'));
        setLoading(false);
      });
  }, [uid]);

  let content;
  if (loading) {
    content = <Loading size={56} />;
  } else if (error) {
    content = <OAuthError message={<Typography>{error}</Typography>} />;
  } else if (interaction?.client) {
    const scopes = (interaction.params?.scope || '').split(' ').filter(Boolean);
    content = (
      <OAuthAuthorize
        client={interaction.client}
        scopes={scopes}
        interactionUid={uid}
        clientType={interaction.client.clientType}
      />
    );
  } else {
    content = (
      <OAuthError
        message={<Typography>{I18n.t('OAuth.Invalid client_id parameter')}</Typography>}
      />
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Header hideNavigation />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <Grid
          spacing={4}
          sx={{
            mt: 4,
            maxWidth: 480,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {content}
        </Grid>
      </Box>
    </Box>
  );
};

export default deferRender(OAuthScene);
